import React, { Component } from 'react';

import {
    Spin,
    Card,
    Statistic,
} from 'antd';

class InfoCard extends Component {
    render() {
        const { loading, title, metric, suffix, icon, isDate } = this.props;
        const Icon = icon || (props => <div {...props}></div>);
        return (
            <Card
                size="small"
                className="info-card"
                bodyStyle={{ padding: 0, display: 'flex', alignItems: 'center', margin: '10px 0 0 0', textAlign: 'left' }}
            >
                <Icon style={{ margin: '0 20px', fontSize: '30px' }} />
                {loading && <Spin />}
                {!loading && <Statistic
                    title={title}
                    value={metric}
                    valueStyle={{ color: '#595959', fontSize: '17px', fontWeight: 500 }}
                    suffix={suffix}
                />}
            </Card>
        );
    }
}

export default InfoCard;